import { inject, injectable } from 'inversify';
import {
  ApiGlobalConfigServiceInterface,
  GetGlobalConfigBySlugRequestParams,
  GlobalConfigResponse,
} from 'src/common/apiGlobalConfig/ApiGlobalConfigServiceInterface';
import { backendUrl } from 'src/config';
import HttpClient from 'src/features/http';

@injectable()
class ApiGlobalConfigService implements ApiGlobalConfigServiceInterface {
  @inject(HttpClient) private readonly client!: HttpClient;

  async getConfigBySlug<T>(params: GetGlobalConfigBySlugRequestParams) {
    return await this.client
      .getClient()
      .get<GlobalConfigResponse<T>>(`/globalconfig/${params.slug}/`, {
        baseURL: backendUrl,
        headers: {
          Authorization: `Token ${params.accessToken}`,
        },
      });
  }
}

export default ApiGlobalConfigService;
